import React from 'react';
import { Button, ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import ProForm, { ModalForm, ProFormDependency } from '@ant-design/pro-form';
import { SearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import {
  SelectFaculty,
  SelectDepartment,
  SelectUserFromHroStaff,
} from 'components/input';

const SearchUserFromHroModalForm = ({ postFinish }) => {
  const [form] = ProForm.useForm();

  return (
    <ConfigProvider locale={enUS}>
      <ModalForm
        form={form}
        title="Search user from HRO staff list"
        trigger={
          <Button type="primary" style={{ marginBottom: '24px' }}>
            <SearchOutlined />
            Search user from HRO staff list
          </Button>
        }
        autoFocusFirstInput
        modalProps={{
          onCancel: () => form.resetFields(),
        }}
        onFinish={async (values) => {
          await postFinish(values);
          form.resetFields();
          return true;
        }}
      >
        <SelectFaculty rules={[]} />
        <SelectDepartment rules={[]} form={form} />
        <ProFormDependency name={['department', 'faculty']}>
          {({ department, faculty }) => (
            <SelectUserFromHroStaff
              form={form}
              name="user"
              label="User"
              department={department}
              faculty={faculty}
            />
          )}
        </ProFormDependency>
      </ModalForm>
    </ConfigProvider>
  );
};

SearchUserFromHroModalForm.propTypes = {
  postFinish: PropTypes.func,
};

export default SearchUserFromHroModalForm;
